export const directBookingsSettingsView = {
  loading: "جارٍ تحميل الإعدادات…",

  sidebar: {
    brandTitle: "الإعلانات",
    brandSub: "لوحة الإعدادات",
    searchPlaceholder: "بحث…",
    generalLabel: "عام",
    servicesName: "الخدمات والتجارب",
    servicesSub: "قائمة واحدة للحساب كله",
    promotionsName: "العروض",
    promotionsSub: "إنشاء · تعديل · إدارة",
    globalChip: "عام",
    inactivePrefix: "غير مفعّل · {type}",
    unitsCount: "{count} وحدة | {count} وحدات",
    empty: "لا توجد عقارات.",
    listingFallbackName: "إعلان",
  },

  status: {
    active: "مفعّل",
    inactive: "غير مفعّل",
  },

  card: {
    unsavedChanges: "تغييرات غير محفوظة",
  },

  share: {
    title: "رابط الحجز المباشر",
    hintPrefix: "شارك رابط",
    hintSuffix: "لاستقبال حجوزات دون عمولات.",
    copyTitle: "نسخ الرابط",
    viewAsVisitor: "المعاينة كزائر",
    copied: "تم نسخ الرابط.",
    copyError: "تعذّر نسخ الرابط.",
    whatsappText: "مرحبًا 👋 إليك رابط الحجز: {link}",
  },

  savebar: {
    unsaved: "تغييرات غير محفوظة",
    noChanges: "لا توجد تغييرات معلّقة",
    saving: "جارٍ الحفظ…",
  },

  drawer: {
    close: "إغلاق",
  },

  content: {
    selectListing: "اختر إعلانًا",
  },

  units: {
    pickerHint: "فعّل أو ألغِ ظهور كل وحدة في الحجز المباشر، أو ادخل لإعدادها (الأسعار والصور والوصف والخدمات والرسوم).",
    visible: "ظاهرة",
    hidden: "مخفية",
    showTooltip: "إظهار هذه الوحدة في الحجز المباشر",
    configure: "إعداد",
  },

  header: {
    listingSub: "إعلان · {count} وحدة · حجوزات مباشرة | إعلان · {count} وحدات · حجوزات مباشرة",
    unitSub: "وحدة · إعداد فردي",
    unitSubCoded: "وحدة {code} · إعداد فردي",
    hotelSub: "فندق / تخييم · حجوزات مباشرة",
    apartmentSub: "شقة / فيلا · حجوزات مباشرة",
  },

  tabs: {
    reservations:       { label: "ظهور الإعلان",       sub: "فعّله واضبط الدفع والموافقة في الحجز المباشر" },
    units_list:         { label: "الوحدات",            sub: "الوحدات القابلة للحجز" },
    common_images:      { label: "المناطق المشتركة",   sub: "صور المبنى المشتركة (الغلاف)" },
    rate_plans:         { label: "الأسعار",            sub: "خطط الأسعار الظاهرة" },
    images:             { label: "الصور",              sub: "معرض الإعلان" },
    description:        { label: "الوصف",              sub: "نص الإعلان وتفاصيله" },
    services:           { label: "الخدمات",            sub: "الخدمات والتجهيزات" },
    promotions:         { label: "العروض",             sub: "طريقة ظهورها في هذا الإعلان" },
    addons:             { label: "الإشغال",            sub: "الخصومات والضيف الإضافي" },
    age_rules:          { label: "قواعد الضيوف",       sub: "الرُّضّع والأطفال والسعة" },
    additional_charges: { label: "الرسوم والضرائب",    sub: "ضريبة القيمة المضافة والتنظيف والرسوم" },
    web_embed:          { label: "الدمج في الويب",     sub: "أضف مربّع البحث إلى موقعك" },
  },

  save: {
    ratePlans: "حفظ الأسعار",
    promotions: "حفظ العروض",
    addons: "حفظ الرسوم",
    ageRules: "حفظ القواعد",
    additionalCharges: "حفظ الرسوم والضرائب",
    payments: "حفظ المدفوعات",
    default: "حفظ",
  },

  types: {
    apartment: "شقة",
    house: "منزل",
    villa: "فيلا",
    loft: "لوفت",
    room: "غرفة",
    studio: "استوديو",
    cabin: "كوخ",
    hotel: "فندق",
    hostel: "بيت شباب",
    camping: "تخييم",
  },

  toasts: {
    unitVisible: "الوحدة ظاهرة في الحجز المباشر.",
    unitHidden: "الوحدة مخفية.",
    unitUpdateError: "تعذّر تحديث الوحدة.",
  },

  errors: {
    noUserUuid: "لم يُعثر على معرّف UUID للمستخدم.",
    loadPage: "تعذّر تحميل الصفحة.",
    loadContext: "تعذّر تحميل السياق.",
    saveExec: "تعذّر تنفيذ الحفظ.",
    saveGeneric: "تعذّر الحفظ.",
  },

  misc: {
    propertyFallback: "عقار {id}",
  },
};
